export default {
  items: []
}



// WEBPACK FOOTER //
// ./src/store/modules/plans/state.js